import Hashids from 'hashids';
import { getPublicConfig } from './configService';

let _hashids: Hashids | null = null;

const getHashids = (): Hashids => {
    if (!_hashids) {
        _hashids = new Hashids(getPublicConfig().hashidsSalt);
    }
    return _hashids;
};

export const encode = (id: number): string => {
    return getHashids().encode(id);
}

export const decode = (text: string): number => {
    return Number(getHashids().decode(text)[0]);
}